
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/competition-standings",
      function () {
        return require("private-next-pages/competition-standings.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/competition-standings"])
      });
    }
  